import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCadeadoService {

  constructor(private http: HttpClient,
    public global: GlobalService) { }
    user = this.global.user;
    pass = this.global.pass;
    auth = btoa(this.user + ':' + this.pass);

dominio = this.global.dominio;
categoriaUrl = this.dominio + '/backend/api/v2/cadeado';

verificarTrava(codigo: any): Promise<any> {
let headers = new HttpHeaders();
headers = headers.set('Authorization', 'Basic ' + this.auth);
return this.http.get(`${this.categoriaUrl}/verificar/${codigo}`, {headers})
.toPromise();
}


abrirTrava(codigo: any): Promise<any> {
  let headers = new HttpHeaders();
  headers = headers.set('Authorization', 'Basic ' + this.auth);
  return this.http.get(`${this.categoriaUrl}/abrir/${codigo}`, {headers})
  .toPromise();
  }


  fecharTrava(codigo: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.categoriaUrl}/fechar/${codigo}`, {headers})
    .toPromise();
    }


}


